
import React from "react";
import { CCarousel,CImage,CCarouselItem} from '@coreui/react';
import CssBaseline from '@mui/material/CssBaseline';
import {Box,Tab,Tabs,AppBar,Typography,TextField,InputLabel,Select,OutlinedInput,MenuItem,FormControl,Card,CardContent,Grid} from '@mui/material';
import '../style/style.scss';

const Homepage = () => {




return(<>     
     <CssBaseline />
    
   <Grid item xs={6}>
<Card >
<CardContent>
Ciao , {sessionStorage.getItem("username")} !
</CardContent>
</Card>
</Grid>
<Grid item xs={6}>
        
</Grid>
</>
)

}



export default Homepage;